import {createModel} from '@rematch/core';

import {fetchMyReviews} from '~/services/hot-api/reviews';

import type {RootModel} from '.';

export type ReviewsState = any;

export const reviews = createModel<RootModel>()({
  state: {
    data: [],
    loading: true,
  },
  reducers: {
    set: (_: ReviewsState, payload: any) => ({
      data: payload,
      loading: false,
    }),
  },
  effects: (dispatch) => {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const {reviews} = dispatch;

    return {
      async loadReviews(): Promise<void> {
        const response = await fetchMyReviews();

        reviews.set(response.data.items);
      },
    };
  },
});
